import React from 'react';
import {
    RoleAvatar,
    RoleName,
    RoleSelectDialog as RoleSelectDialogBase,
    RoleSelectDialogProps
} from '@fx-ui/jdy-design-biz';
import { RoleType } from '../../interfaces';
import ValueTag from '../value-tag';
import RoleCard from '../role-card';
import { tracker } from '../../utils';
import { TRACKER } from '../../constants';
import { includes } from '@libs/shared';

const RoleSelectDialog: React.FC<RoleSelectDialogProps> = (props) => {
    return (
        <RoleSelectDialogBase
            renderTag={(role, options) => (
                <ValueTag
                    valueKey={role._id}
                    icon={<RoleAvatar type={role.type} source={role.source} />}
                    name={<RoleName name={role.name} status={role.status} />}
                    tagOptions={options}
                    popoverOptions={
                        includes([RoleType.corp_coop, RoleType.external], role.type)
                            ? undefined
                            : {
                                  content: <RoleCard roleId={role._id} />
                              }
                    }
                />
            )}
            onRoleGroupCheck={() => {
                tracker(TRACKER.MEMBER_ROLE_GROUP_CHECK);
            }}
            {...props}
        />
    );
};

export default RoleSelectDialog;
